import { get_fixed_project_folder, get_lang } from "utils/util";
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

let routes = [
  {
    //  home
    path: "/home",
    name: "home",
    component: () => import("@/views/home/index.vue"),
    alias: "/",
    meta: {
      title: "首页",
      order: 1,
      prefetchAssets: {
        isLoad: false,
        assets: [
          "images/home/starry-sky.jpg",
          "images/home/earth.png",
          "loading/title.png",
        ],
      },
    },
  },
];

const requireContext = require.context("./", true, /\.js$/);

requireContext.keys().forEach((fileName) => {
  if (fileName === "./index.js") return;
  const routerModule = requireContext(fileName);
  routes = [...routes, ...(routerModule.default || routerModule)];
});

if (process.env.NODE_ENV === "development") {
  routes = routes.concat([
    {
      path: "/framework",
      name: "framework",
      component: () => import("@/views/framework/index.vue"),
      meta: { title: "底层", order: 22 },
    },
    /*    {
      path: "/jy-test",
      name: "jy-test",
      component: () => import("@/views/jy-test.vue"),
      meta: { title: "谨严的测试页面", order: 23 },
    },
    {
      path: "/hn-test",
      name: "hn-test",
      component: () => import("@/views/hn-test.vue"),
      meta: { title: "宏恩的测试页面", order: 24 },
    },
    {
      path: "/lh-test",
      name: "lh-test",
      component: () => import("@/views/lh-test.vue"),
      meta: { title: "刘豪测试", order: 25 },
    },*/
  ]);
}

//  对路由进行排序
routes = routes.sort((a, b) => {
  return a.meta.order - b.meta.order;
});

let publicPath = "/";
if (process.env.NODE_ENV === "production") {
  let lang = get_lang();
  let secondFolder = ["ru", "it", "fr", "es", "de"];
  if (
    secondFolder.includes(lang) &&
    !window.location.href.includes("godfootsteps")
  ) {
    publicPath = `/${lang}/special-topic/${get_fixed_project_folder()}/`;
  } else {
    publicPath = `/special-topic/${get_fixed_project_folder()}/`;
  }
}

const router = new Router({
  mode: "history",
  scrollBehavior: (to, from, savedPosition) => {
    return {
      x: 0,
      y: 0,
    };
  },

  base: publicPath,
  routes,
});

export default router;
